module.exports = __webpack_public_path__ + "static/img/yingxiao_icon3.381bb71.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flow/broadcast/yingxiao_icon3.png
// module id = Z6mz
// module chunks = 0